import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-terms',
  templateUrl: 'terms.html',
})
export class TermsPage {
  regType: string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    console.log(navParams.get('regType'));
    this.regType = navParams.get('regType');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TermsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/terms/terms.ts